/**
 * Strings for the account and sign-in fixes of 2026-10-29: sign-up modes
 * from the console, the web or desktop app turned off, invite links, a
 * forced rename and the username in Settings, the "This wasn't me" link, why
 * a session ended.
 */
import type { Dict } from './core';

export const accountEn: Dict = {
  'auth.mfa.recoveryWrong': "That recovery code doesn't work or was already used.",
  'security.stepUp.passwordBody': 'Enter your password to continue.',
  'security.stepUp.codeBody':
    'Enter the code from your authenticator app, or one of your recovery codes, to continue.',
  'auth.alpha.optional': 'Invite code (optional)',
  'auth.signup.closedTitle': 'Sign-up is closed',
  'auth.signup.inviteOnly': 'You need an invite code to sign up.',
  'auth.ended.title': 'You were signed out',
  'app.off.web.title': 'The web app is turned off',
  'app.off.web.body':
    'The admins have turned the web app off for now. Your account and messages are safe. This page checks again by itself.',
  'app.off.desktop.title': 'The desktop app is turned off',
  'app.off.desktop.body':
    'The admins have turned the desktop app off for now. Your account and messages are safe. This window checks again by itself.',
  'app.off.retry': 'Check again',
  'app.off.signOut': 'Sign out',
  'email.undo.working': 'Putting your email back…',
  'email.undo.done':
    'Your email is back to your own address and every device was signed out. Choose a new password now.',
  'email.add.releasedTitle': 'Your email went to another account',
  'email.add.releasedBody':
    'Another account confirmed the email you signed up with before you did, so it is no longer on your account. Until you add one you own, sign in with your username @{username}.',
  'inviteLink.title': 'Invite to {server}',
  'inviteLink.to': 'To #{channel}',
  'inviteLink.member': "You're already a member of {server}.",
  'inviteLink.go': 'Go to #{channel}',
  'inviteLink.join': 'Join',
  'inviteLink.invalid': 'This invite is invalid or has expired.',
  'inviteLink.signup': 'Sign up with this invite',
  'profile.username.label': 'Username',
  'profile.username.change': 'Change',
  'profile.username.title': 'Change your username',
  'profile.username.help':
    'Your @handle: friends find and mention you by it. Lowercase letters, numbers, dots and underscores. You can change it twice a week.',
  'profile.username.save': 'Save',
  'profile.username.done': 'Your username is now @{name}.',
  'profile.username.taken': 'That username is taken.',
  'profile.username.invalid': "That username isn't allowed. Check the rules above.",
  'profile.username.wait': 'You changed your username recently. Try again in {n} days.',
  'profile.username.mustTitle': 'Choose a new username',
  'profile.username.mustBody':
    'The admins reset your username. Choose a new one to go on: people find and mention you by it.',
};
